
import { apiErrorCopy } from "~/utils/apiError";

export default {
  data() {
    return {
      email: "",
      isSubmitting: false,
      submitted: false,
      submitError: null,
    };
  },
  methods: {
    submit() {
      const email = this.loggedIn ? this.$auth.user.email : this.email;

      this.isSubmitting = true;
      this.submitError = null;

      // Same defect as ExpertMatchResponseModelAction's submit: with no
      // `.catch` the rejection escaped as an `onunhandledrejection` and the
      // only thing the user saw was the spinner stop -- indistinguishable, on
      // a button they had just pressed, from nothing having happened.
      return this.$nuxt.$api
        .POST("resend-verification-email", { email }, "")
        .then((res) => {
          this.submitted = true;
          this.$emit("submitted");
        })
        .catch((error) => {
          // Deliberately logs whether the address came from the session rather
          // than the address itself: this component runs for logged-out users
          // too and the email is theirs, not ours to put in a console.
          console.error(
            "Resend verification email failed:",
            { loggedIn: this.loggedIn },
            error
          );

          this.submitError = apiErrorCopy(error).message;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn;
    },
    valid() {
      if (this.loggedIn) return true;

      return (
        this.email &&
        this.email.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        )
      );
    },
  },
};
